import { defineMessages } from 'react-intl';

export default defineMessages({
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  borrow: 'Borrow',
  repay: 'Repay',
  swap: 'Swap',
  stake: 'Stake',
  claim: 'Claim',
});
